<template>
  <!--  <b-modal size="xl" id="modal-detail-brs" centered title="Detail Internal Memo BRS" hide-footer @show="onModalShow()">-->
  <div class="row">
    <b-tabs content-class="mt-3" pills fill>
      <b-tab title="IM BRS Detail">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title mb-3 font-weight-bold">Detail Internal Memo - {{ detailInfo?.name }}</div>
            </div>
            <div class="card-body">
              <div class="row row row-cols-1 row-cols-md-2 row-cols-xl-4 gx-5 gy-3">
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-home"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Category</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detailInfo?.im_category }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-credit-card"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Number</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detailInfo?.im_number }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Year</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detailInfo?.im_year }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Used IM Values</h4>
                      <small class="text-body-secondary"
                        ><span> {{ formatedUsedValue }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Remaining IM Values</h4>
                      <small class="text-body-secondary"
                        ><span> {{ formatedRemainingValue }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Total IM Values</h4>
                      <small class="text-body-secondary"
                        ><span> {{ formatedImValue }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Created At</h4>
                      <small class="text-body-secondary"
                        ><span> {{ createdAt }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-user"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Created By</h4>
                      <small class="text-body-secondary"
                        ><span> {{ createdBy }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Updated At</h4>
                      <small class="text-body-secondary"
                        ><span> {{ updatedAt }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-user"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Updated By</h4>
                      <small class="text-body-secondary"
                        ><span> {{ updatedBy }}</span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header font-weight-bold">Internal Memo Files</div>
            <div class="card-body">
              <div v-for="(attachment, index) in detail?.attachments" :key="index">
                <span> {{ index == 0 ? 'Internal Memo' : `Lampiran ${index}` }}: </span>
                <a v-if="attachment?.url" :href="attachment?.url || ''" target="_blank">
                  {{ attachment?.name ? attachment?.name : attachment?.filename }}
                </a>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header font-weight-bold">Internal Memo Project</div>
            <div class="card-body">
              <div class="row row-cols-1 row-cols-md-4" v-if="detail?.im_projects?.length > 0">
                <div class="col form-group">
                  <v-select
                    v-model="selectedProject"
                    :options="detail?.im_projects"
                    label="project_name"
                    placeholder="Select Project"
                    class="w-100"
                    :clearable="false"
                  />
                </div>
              </div>
              <div class="row row-cols-1 row-cols-md-2 gx-3 gy-5" v-if="selectedProject?.project_name">
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-home"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Project Name</h4>
                      <small class="text-body-secondary"
                        ><span> {{ selectedProject?.project_name }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-hash"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Total Project Relocations</h4>
                      <small class="text-body-secondary"
                        ><span> {{ selectedProject?.project_relocations?.length }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                      <small class="text-body-secondary"
                        ><span> {{ `Rp. ${convertNumber(selectedProject?.relocate_value)}` }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Relocation Remaining</h4>
                      <small class="text-body-secondary"
                        ><span>
                          {{
                            `Rp. ${convertNumber(
                              selectedProject?.relocate_value -
                                selectedProject?.project_relocations?.reduce((a, b) => a + parseInt(b.relocate_value), 0)
                            )}`
                          }}</span
                        >
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion mt-3" role="tablist">
                <b-card no-body class="mb-1" v-for="(item, index) in selectedProject?.project_relocations">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle:[`accordion-${index}`] variant="danger">Relocation {{ index + 1 }}</b-button>
                  </b-card-header>
                  <b-collapse :id="`accordion-${index}`" :visible="index == 0" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="row row-cols-1 row-cols-md-2 gx-3 gy-3">
                        <div class="col">
                          <div class="card p-3">
                            <label class="font-weight-bold">From</label>
                            <div class="row row-cols-1 row-cols-lg-2 gx-3 gy-5">
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Departmen From</h4>
                                    <small class="text-body-secondary"
                                      ><span> {{ item?.budget_task_from_detail?.department_name }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Plan Title From</h4>
                                    <small class="text-body-secondary"
                                      ><span>
                                        {{
                                          `${item?.budget_task_from_detail?.plan_title} version ${item?.budget_task_from_detail?.plan_version}`
                                        }}</span
                                      >
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Fund From</h4>
                                    <small class="text-body-secondary"
                                      ><span>
                                        {{ `${item?.budget_task_from_detail?.budget_type} | ${item?.budget_task_from_detail?.fund_name}` }}</span
                                      >
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">GL From</h4>
                                    <small class="text-body-secondary">
                                      <span>
                                        {{ `${item?.budget_task_from_detail?.gl_code} | ${item?.budget_task_from_detail?.account_name}` }}
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Budget Task From</h4>
                                    <small class="text-body-secondary"
                                      ><span> {{ item?.budget_task_from_detail?.name }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-dollar-sign"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                                    <small class="text-body-secondary"
                                      ><span>Rp. {{ convertNumber(item?.relocate_value) }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="card p-3">
                            <label class="font-weight-bold">To</label>
                            <div class="row row-cols-1 row-cols-lg-2 gx-3 gy-5">
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Departmen To</h4>
                                    <small class="text-body-secondary"
                                      ><span> {{ item?.budget_task_to_detail?.department_name }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Plan Title To</h4>
                                    <small class="text-body-secondary"
                                      ><span>
                                        {{ `${item?.budget_task_to_detail?.plan_title} version ${item?.budget_task_to_detail?.plan_version}` }}</span
                                      >
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Fund To</h4>
                                    <small class="text-body-secondary"
                                      ><span> {{ `${item?.budget_task_to_detail?.budget_type} | ${item?.budget_task_to_detail?.fund_name}` }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">GL To</h4>
                                    <small class="text-body-secondary">
                                      <span>
                                        {{ `${item?.budget_task_to_detail?.gl_code} | ${item?.budget_task_to_detail?.account_name}` }}
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-home"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Budget Task To</h4>
                                    <small class="text-body-secondary"
                                      ><span> {{ item?.budget_task_to_detail?.name }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div class="col">
                                <div class="row align-items-center">
                                  <div class="col-auto">
                                    <div class="avatar avatar-sm">
                                      <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                        <i class="fe fe-dollar-sign"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col ms-n2">
                                    <h4 class="mb-1 font-weight-bold">Relocation Value</h4>
                                    <small class="text-body-secondary"
                                      ><span>Rp. {{ convertNumber(item?.relocate_value) }}</span>
                                    </small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <b-collapse class="mt-3"> </b-collapse>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="List PR/PO linked to BRS">
        <div class="row row-cols-1 row-cols-md-4">
          <div class="col form-group">
            <label>Project</label>
            <v-select
              v-model="filterPo.project_id"
              :options="detail?.im_projects"
              label="project_name"
              :reduce="(item) => item.id"
              placeholder="Select Project"
              @input="filterPo.relocation_id = ''"
              class="w-100"
            />
          </div>
          <div class="col form-group">
            <label>Relocation</label>
            <v-select
              v-model="filterPo.relocation_id"
              :options="filteredRelocation"
              :reduce="(item) => item.id"
              label="label"
              placeholder="Select Relocation"
              class="w-100"
            />
          </div>
          <div class="col form-group">
            <label>Relocation Value</label>
            <input type="text" :value="`Rp. ${convertNumber(selectedFilteredValue)}`" class="form-control" readonly />
          </div>
          <div class="col form-group">
            <button class="btn btn-primary mt-4" @click="resetFilterPo">Reset</button>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12 col-md-6 offset-md-6">
                <div class="d-flex justify-content-end">
                  <div class="ml-3" v-if="relocationStatus.status !== ''">
                    Status:
                    <div :class="statusColor">{{ relocationStatus.status }}</div>
                  </div>
                  <div class="ml-3" v-if="relocationStatus.value > 0">
                    {{ relocationStatus.status == 'Underutilized' ? 'Underutilized By' : 'Exceed By' }}:
                    <div :class="statusColor">Rp. {{ convertNumber(relocationStatus.value) }}</div>
                  </div>
                  <div class="ml-3">
                    <input type="text" v-model="filterPo.search" placeholder="Search..." class="form-control" />
                  </div>
                </div>
              </div>
            </div>

            <vue-good-table
              :line-numbers="true"
              :columns="columnsActual"
              :rows="filteredActual"
              :total-rows="filteredActual.length"
              :pagination-options="{
                enabled: true,
                perPage: filterPo.perPage,
              }"
              style-class="vgt-table border-0 table"
            >
              <div slot="emptystate" class="text-center font-size-14">No data available</div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'po_value'">Rp. {{ convertNumber(props.row.po_value) }}</span>
                <span v-else>{{ props.row[props.column.field] }}</span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
  <!--  </b-modal>-->
</template>

<script>
import moment from 'moment';
import axiosIns from '@/api/axios';
import boolean from 'vue-good-table/src/components/types/boolean';
export default {
  name: 'DetailBRS',
  props: { dataDetail: Object, loadData: boolean, oldData: Object },
  mounted() {
    if (this.loadData) {
      this.detail = this.dataDetail;
      this.selectedProject = this.detail?.im_projects?.[0] || {};
      this.detailInfo = this.oldData;
    }
  },
  data() {
    return {
      detail: [],
      detailInfo: [],
      selectedProject: { project_name: '' },
      filterPo: {
        project_id: '',
        relocation_id: '',
        perPage: 10,
        search: '',
      },
      columnsActual: [
        {
          label: 'Project Name',
          field: 'project_name',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'Relocation',
          field: 'relocation_name',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'Department To',
          field: 'department_to',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'GL',
          field: 'gl_name',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'Budget Task',
          field: 'budget_task_name',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'PO Number',
          field: 'po_subject',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
        {
          label: 'PO Value',
          field: 'po_value',
          sortable: false,
          tdClass: 'nowrap-cell',
        },
      ],
    };
  },
  computed: {
    /*detail() {
      console.log('loadData: ', this.loadData);
      if (this.loadData) {
        this.detail = this.dataDetail;
        this.selectedProject = this.detail?.im_projects?.[0] || {};
        console.log('detail: ', this.detail);
      }
      //return this.$store.getters['imNumber/detail'] || null;
    },*/
    createdAt() {
      return this.detailInfo?.created_at ? moment(this.detail?.created_at).format('DD MMM YYYY HH:mm') : moment().format('DD MMM YYYY HH:mm');
    },
    updatedAt() {
      return this.detailInfo?.updated_at ? moment(this.detail?.updated_at).format('DD MMM YYYY HH:mm') : moment().format('DD MMM YYYY HH:mm');
    },
    createdBy() {
      return this.detail?.created_by_user?.fullname || 'System';
    },
    updatedBy() {
      return this.detail?.updated_by_user?.fullname || 'System';
    },
    usedValue() {
      console.log('usedValue: ', this.detail);
      return [];
      //return this.detail?.budget_relocates?.reduce((acc, item) => acc + Number(item.totalPoValue), 0);
    },
    remainingValue() {
      const imValue = Number(this.detail?.relocate_value) || 0;
      return imValue - this.usedValue;
    },
    formatedUsedValue() {
      return `Rp. ${this.convertNumber(this.usedValue)}`;
    },
    formatedRemainingValue() {
      return `Rp. ${this.convertNumber(this.remainingValue)}`;
    },
    formatedImValue() {
      const totalImValue = this.detail?.relocate_value;
      return `Rp. ${this.convertNumber(totalImValue)}`;
    },
    filteredRelocation() {
      const options = this.detail?.im_projects
        ? this.detail?.im_projects?.find((item) => item.id === this.filterPo.project_id)?.project_relocations || []
        : [];
      return options.map((item, index) => ({
        label: `Relocation ${index + 1}`,
        ...item,
      }));
    },
    selectedRelocation() {
      return this.filteredRelocation.find((item) => item.id === this.filterPo.relocation_id) || {};
    },
    filteredActual() {
      let mappedActuals = [];

      if (this.detail?.budget_relocates) {
        this.detail?.budget_relocates?.forEach((relocate) => {
          if (relocate.relocate_type != 'INT-INT-TO') {
            const actuals = relocate.budget_actuals || [];

            let foundProject = null;
            let foundRelocation = null;
            let relocationIndex = -1;

            if (this.detail?.im_projects) {
              for (const project of this.detail.im_projects) {
                const relocs = project.project_relocations || [];
                const idx = relocs.findIndex((r) => r.id == relocate.im_projects_relocates_id);
                if (idx !== -1) {
                  foundProject = project;
                  foundRelocation = relocs[idx];
                  relocationIndex = idx;
                  break;
                }
              }
            }

            const relocationDetail = foundRelocation?.budget_task_to_detail || {};

            actuals.forEach((item) => {
              mappedActuals.push({
                ...item,
                project_id: foundProject?.id,
                relocation_id: foundRelocation?.id,
                project_name: foundProject?.project_name,
                relocation_name: foundRelocation ? `Relocation ${relocationIndex + 1}` : '',
                department_to: relocationDetail?.department_name,
                gl_name: `${relocationDetail?.gl_code} - ${relocationDetail?.account_name}`,
                budget_task_name: relocationDetail?.name,
              });
            });
          }
        });
      }

      if (this.filterPo.project_id) {
        mappedActuals = mappedActuals.filter((item) => item.project_id === this.filterPo.project_id);
      }

      if (this.filterPo.relocation_id) {
        mappedActuals = mappedActuals.filter((item) => item.relocation_id === this.filterPo.relocation_id);
      }

      // If have search
      if (this.filterPo.search) {
        const searchTerm = this.filterPo.search.toLowerCase().trim();
        mappedActuals = mappedActuals.filter((item) => {
          // Search through all properties of the item
          return Object.values(item).some((value) => {
            if (value === null || value === undefined) return false;
            return value.toString().toLowerCase().includes(searchTerm);
          });
        });
      }

      // Sort by id desc
      return mappedActuals.sort((a, b) => b.id - a.id) || [];
    },
    relocationStatus() {
      const relocateValue = Number(this.selectedFilteredValue) || 0;
      const totalPoValue = this.filteredActual.reduce((acc, item) => acc + Number(item.po_value), 0);
      let status = '';
      if (totalPoValue > 0 && totalPoValue === relocateValue) {
        status = 'Fulfilled';
      } else if (totalPoValue < relocateValue) {
        status = 'Underutilized';
      } else if (totalPoValue > relocateValue) {
        status = 'IM Value Exceed';
      }
      return {
        status,
        value: totalPoValue > relocateValue ? totalPoValue - relocateValue : relocateValue - totalPoValue,
      };
    },
    statusColor() {
      if (this.relocationStatus.status == 'Fulfilled') return 'text-success';
      if (this.relocationStatus.status == 'Underutilized') return 'text-warning';
      if (this.relocationStatus.status == 'IM Value Exceed') return 'text-danger';
    },
    selectedFilteredValue() {
      if (this.filterPo.relocation_id) {
        return this.selectedRelocation?.relocate_value;
      } else if (this.filterPo.project_id) {
        return this.detail?.im_projects?.find((item) => item.id === this.filterPo.project_id)?.relocate_value;
      } else {
        return this.detail?.relocate_value;
      }
    },
  },
  methods: {
    /*async onModalShow() {
      if (this.loadData) {
        this.detail = this.dataDetail;
        this.selectedProject = this.detail?.im_projects?.[0] || {};
        console.log('detail: ', this.detail);
      }
    },*/
    convertNumber(dat) {
      if (dat) {
        return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return 0;
      }
    },
    resetFilterPo() {
      this.filterPo = {
        project_id: '',
        relocation_id: '',
        perPage: 10,
        search: '',
      };
    },
  },
};
</script>

<style>
.nowrap-cell {
  white-space: nowrap;
}
</style>
